import SalidasAgrupadasPage from './SalidasAgrupadasPage'
export default function DistribucionPage() {
  return <SalidasAgrupadasPage titulo="En distribución" estadoFijo="despachada" />
}
